const dismissKey = (campaignId: string) => `promo:${campaignId}:dismissed`
const convertKey = (campaignId: string) => `promo:${campaignId}:converted`

function readFlag(key: string): boolean {
  try {
    return localStorage.getItem(key) === 'true'
  } catch {
    return false
  }
}

function writeFlag(key: string): void {
  try {
    localStorage.setItem(key, 'true')
  } catch {
    // Private browsing / storage blocked — state lasts for this session only.
  }
}

export function isPromotionDismissed(campaignId: string): boolean {
  return readFlag(dismissKey(campaignId))
}

export function isPromotionConverted(campaignId: string): boolean {
  return readFlag(convertKey(campaignId))
}

export function dismissPromotion(campaignId: string): void {
  writeFlag(dismissKey(campaignId))
}

export function convertPromotion(campaignId: string): void {
  writeFlag(convertKey(campaignId))
}

/** True when the user should never see this campaign again. */
export function isPromotionClosed(campaignId: string): boolean {
  return isPromotionDismissed(campaignId) || isPromotionConverted(campaignId)
}
